import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'
import useAtmosphere from '~/hooks/useAtmosphere'

import AzureDevOpsConfigMenu from '../../../../components/AzureDevOpsConfigMenu'
import AzureDevOpsProviderLogo from '../../../../components/AzureDevOpsProviderLogo'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps, {} from '../../../../hooks/useMutationProps'
import {Providers} from '../../../../types/constEnums'
import AzureDevOpsClientManager from '../../../../utils/AzureDevOpsClientManager'
import ProviderRow from './ProviderRow'






graphql`
  fragment AzureDevOpsProviderRowTeamMember on TeamMember {
    integrations {
      azureDevOps {
        id
        auth {
          accessToken
        }
        cloudProvider {
          id
          tenantId
          clientId
        }
        sharedProviders {
          id
          tenantId
          clientId
        }
      }
    }
  }
`

const AzureDevOpsProviderRow = (props) => {
  const {viewerRef, teamId} = props
  const viewer = useFragment(
    graphql`
      fragment AzureDevOpsProviderRow_viewer on User {
        teamMember(teamId: $teamId) {
          ...AzureDevOpsProviderRowTeamMember @relay(mask: false)
        }
      }
    `,
    viewerRef
  )
  const atmosphere = useAtmosphere()
  const {submitting, submitMutation, error, onError, onCompleted} = useMutationProps()
  const mutationProps = {submitting, submitMutation, onError, onCompleted} 
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {azureDevOps} = integrations
  const provider = _nullishCoalesce(_optionalChain([azureDevOps, 'optionalAccess', _ => _.sharedProviders, 'access', _2 => _2[0]]), () => ( _optionalChain([azureDevOps, 'optionalAccess', _3 => _3.cloudProvider])))
  const accessToken = _nullishCoalesce(_optionalChain([azureDevOps, 'optionalAccess', _4 => _4.auth, 'optionalAccess', _5 => _5.accessToken]), () => ( undefined))
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)

  if (!provider) return null

  const openOAuth = async () => {
    await AzureDevOpsClientManager.openOAuth(atmosphere, teamId, provider, mutationProps)
  }

  return (
    _jsxs(_Fragment, { children: [
      _jsx(ProviderRow, {
        connected: !!accessToken,
        onConnectClick: openOAuth,
        submitting: submitting,
        togglePortal: togglePortal,
        menuRef: originRef,
        providerName: Providers.AZUREDEVOPS_NAME,
        providerDescription: Providers.AZUREDEVOPS_DESC,
        providerLogo: _jsx(AzureDevOpsProviderLogo, {} ),
        error: _optionalChain([error, 'optionalAccess', _6 => _6.message]),}
      )
      , menuPortal(
        _jsx(AzureDevOpsConfigMenu, {
          menuProps: menuProps,
          mutationProps: mutationProps,
          teamId: teamId,
          provider: provider,}
        )
      )
    ]})
  )
}

export default AzureDevOpsProviderRow
